module.exports = __webpack_public_path__ + "static/img/product7.b56f310.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/red/product7.png
// module id = UjSF
// module chunks = 0